import React, { useEffect, useState } from "react";
import Logo from "../../../Pyragon/PyraGon.png";
import Twitter from "../../../Pyragon/twitter.png";
import Email from "../../../Pyragon/discord.png";
import TeleGeam from "../../../Pyragon/telegram.png";
import Bitcoin from "../../../Pyragon/medium.png";
import Modal2 from "../../modals/modal2/Modal2";
import "./navbar-mobile.css";
import MenuOpen from "../../../images/menu-icon-1.png";
import MenuClose from "../../../images/menu-icon-2.png";
import HamburgerMenu from "react-hamburger-menu";
import { Link } from "react-router-dom";
const NavBarMobile = () => {
  // const [openModal1 , setOpenModal1] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [open, setOpen] = useState(false);

  let dashboard;
  let social;
  let navGroup;

  useEffect(() => {
    dashboard = document.getElementById("dashboard-mobile");
    social = document.getElementById("social-mobile");
    navGroup = document.getElementById("nav-links-gorup-mobile");
  });

  const onOpen = () => {
    if (!open) {
      dashboard.style.display = "flex";
      social.style.display = "flex";
      navGroup.style.display = "flex";
      console.log(open);
      setOpen(!open);
    } else {
      dashboard.style.display = "none";
      social.style.display = "none";
      navGroup.style.display = "none";

      setOpen(!open);
      console.log(open);
    }
  };

  // const HandleModal1 = ()=>{
  //   setOpenModal1(true);
  //   onOpen();
  // }
  const HandleModal2 = () => {
    setOpenModal2(true);
    onOpen();
  };

  return (
    <div id="nav-bar-mobile" className="nav-bar-mobile">
      <div id="nav-bar-mobile-small">
        <div id="title-mobile">
          <img
            alt=""
            src={Logo}
            style={{ width: "40px", height: "40px", marginRight: "10px" }}
          />
          PYRAGON
        </div>
        <button id="toggle-nav-menu" onClick={() => onOpen()}>
          <img
            src={open ? MenuClose : MenuOpen}
            style={{ width: "100%", height: "100%" }}
          />
        </button>
      </div>
      {/* <div id="nav-bar-modal1-wrapper">
      <Modal1 isOpen = {openModal1} setIsOpen={setOpenModal1}/>

</div> */}
      <div id="nav-bar-modal1-wrapper">
        <Modal2 isOpen={openModal2} setIsOpen={setOpenModal2} />
      </div>

      <div id="nav-links-gorup-mobile">
        {/* <a class="nav-link-mobile" href="#about-section">
          ABOUT
          <Link to="/about" style={{ color: "white", textDecoration: "none" }}>
            ABOUT{" "}
          </Link>
        </a> */}
        <a class="nav-link" onClick={HandleModal2}>
          TOKENOMICS
        </a>

        <a class="nav-link" href="#features">
          FEATURES
        </a>

        <a class="nav-link" href="#roadmap-main-container">
          ROADMAP
        </a>

        <a class="nav-link" href="#main-container-our-team">
          TEAM
        </a>

        <a class="nav-link" href="#container-footer">
          CONTACT
        </a>

        <a class="nav-link" href="#document-main-container">
          DOCUMENTS
        </a>
      </div>

      <div id="social-mobile">
        <a href="https://t.me/pyragonio" class="social-link-mobile">
          <img src={TeleGeam} style={{ width: "30px", height: "30px" }} />
        </a>
        <a href="https://twitter.com/pyragonio?s=21" class="social-link-mobile">
          <img src={Twitter} style={{ width: "30px", height: "30px" }} />
        </a>
        <a href="https://discord.gg/maEb3zVU" class="social-link-mobile">
          <img src={Email} style={{ width: "30px", height: "32px" }} />
        </a>
        <a class="social-link-mobile">
          <img
            alt="first"
            src={Bitcoin}
            style={{ width: "30px", height: "27px" }}
          />
        </a>
      </div>
      <div id="dashboard-mobile">
        <Link to="/about">
        <button>DASHBOARD</button>
        </Link>      </div>
    </div>
  );
};

export default NavBarMobile;
